<template>
  <div class="control_title_wraper">
    <span class="control_title_left">
      <slot name="left"></slot>
    </span>
    <span class="control_title_text">
      <slot name="text"></slot>
    </span>
    <span class="control_title_img">
      <slot name="img"></slot>
    </span>
    <span class="control_title_text_right">
      <slot name="text-right"></slot>
    </span>
    <span class="control_title_img_right">
      <slot name="img-right"></slot>
    </span>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.control_title_wraper
{
  height: 64px;
  width: 100%;
  font-size: 18px;
  color:#fff;

  display: flex;
  flex-direction:row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items:center;
  /* line-height: 64px; */
}
.control_title_left{
  margin-left: -7px;
}
.control_title_text{
  margin: 0 2PX;
}

.control_title_img{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin: 0 8px;
  cursor: pointer;
}

.control_title_text_right{
  margin-left: auto;
  cursor: pointer;
}
.control_title_img_right{
  margin: 0px 5px;
  cursor: pointer;

}
</style>
